import { lazy, Suspense } from 'react';
import { Redirect, Route, Switch } from 'wouter';
import PublicLayout from './components/PublicLayout';
import HomePage from './pages/public/HomePage';

const StrategiesPage = lazy(() => import('./pages/public/StrategiesPage'));
const StrategyDetailPage = lazy(() => import('./pages/public/StrategyDetailPage'));
const MonitorPage = lazy(() => import('./pages/public/MonitorPage'));
const ToolsPage = lazy(() => import('./pages/public/ToolsPage'));
const InsightsPage = lazy(() => import('./pages/public/InsightsPage'));
const ArticlePage = lazy(() => import('./pages/public/ArticlePage'));
const AboutPage = lazy(() => import('./pages/public/StaticPages').then((module) => ({ default: module.AboutPage })));
const ContactPage = lazy(() => import('./pages/public/StaticPages').then((module) => ({ default: module.ContactPage })));
const RiskPage = lazy(() => import('./pages/public/StaticPages').then((module) => ({ default: module.RiskPage })));
const AdminLoginPage = lazy(() => import('./pages/admin/AdminLoginPage'));
const AdminLayout = lazy(() => import('./pages/admin/AdminLayout'));
const AdminDashboard = lazy(() => import('./pages/admin/AdminDashboard'));
const AdminAccounts = lazy(() => import('./pages/admin/AdminAccounts'));
const AdminArticles = lazy(() => import('./pages/admin/AdminArticles'));
const AdminUsers = lazy(() => import('./pages/admin/AdminUsers'));
const AdminAudit = lazy(() => import('./pages/admin/AdminAudit'));
const AdminInquiries = lazy(() => import('./pages/admin/AdminInquiries'));

const Loading = () => <div className="route-loading">正在加载</div>;
const Public = ({ children }: { children: React.ReactNode }) => <PublicLayout>{children}</PublicLayout>;
const Admin = ({ children }: { children: React.ReactNode }) => <AdminLayout>{children}</AdminLayout>;

export default function App() {
  return <Suspense fallback={<Loading />}><Switch>
    <Route path="/"><Public><HomePage /></Public></Route>
    <Route path="/strategies"><Public><StrategiesPage /></Public></Route>
    <Route path="/strategies/:slug"><Public><StrategyDetailPage /></Public></Route>
    <Route path="/monitor"><Public><MonitorPage /></Public></Route>
    <Route path="/tools"><Public><ToolsPage /></Public></Route>
    <Route path="/insights"><Public><InsightsPage /></Public></Route>
    <Route path="/insights/:slug"><Public><ArticlePage /></Public></Route>
    <Route path="/about"><Public><AboutPage /></Public></Route>
    <Route path="/contact"><Public><ContactPage /></Public></Route>
    <Route path="/risk"><Public><RiskPage /></Public></Route>
    <Route path="/admin/login"><AdminLoginPage /></Route>
    <Route path="/admin"><Admin><AdminDashboard /></Admin></Route>
    <Route path="/admin/accounts"><Admin><AdminAccounts /></Admin></Route>
    <Route path="/admin/articles"><Admin><AdminArticles /></Admin></Route>
    <Route path="/admin/users"><Admin><AdminUsers /></Admin></Route>
    <Route path="/admin/audit"><Admin><AdminAudit /></Admin></Route>
    <Route path="/admin/inquiries"><Admin><AdminInquiries /></Admin></Route>
    <Route><Redirect to="/" /></Route>
  </Switch></Suspense>;
}
